import { Box, Typography, Chip } from '@mui/material';
import { usePublicFoodItems } from '../../food/hooks/usePublicFoodItems';
import { LOV_FSSAI_LICENSE } from '@lov/shared';

interface VenueFoodPreviewProps {
  venueId: string;
}

export function VenueFoodPreview({ venueId }: VenueFoodPreviewProps) {
  const { data: foodItems, isLoading } = usePublicFoodItems(venueId);

  if (isLoading) {
    return (
      <Typography variant="body2" color="text.secondary">
        Loading menu...
      </Typography>
    );
  }

  if (!foodItems || foodItems.length === 0) {
    return null;
  }

  // Show top 6 items
  const topItems = foodItems.slice(0, 6);
  const hasMore = foodItems.length > 6;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          gap: 2,
        }}
      >
        {topItems.map((item) => (
          <Box
            key={item.id}
            sx={{
              p: 2,
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {item.isVegetarian && (
                  <Chip
                    label="VEG"
                    size="small"
                    sx={{
                      height: 18,
                      fontSize: '0.65rem',
                      bgcolor: 'success.light',
                      color: 'success.dark',
                    }}
                  />
                )}
                <Typography variant="body2" fontWeight={500} noWrap>
                  {item.name}
                </Typography>
              </Box>
              {item.category && (
                <Typography variant="caption" color="text.secondary">
                  {item.category.name}
                </Typography>
              )}
            </Box>
            <Typography variant="body2" fontWeight={600} sx={{ ml: 1, flexShrink: 0 }}>
              ₹{Number(item.price).toLocaleString('en-IN')}
            </Typography>
          </Box>
        ))}
      </Box>

      {hasMore && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          +{foodItems.length - 6} more items available during booking
        </Typography>
      )}

      {/* FSSAI Compliance Footer */}
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
        Platform FSSAI: {LOV_FSSAI_LICENSE}
      </Typography>
    </Box>
  );
}
